import React from "react";
import Countdown from "react-countdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "../../../../../hooks/customReduxHooks";
import { StyledContador } from "./ContadorHotSaleStyled";
var ContadorHotSale = function (_a) {
    var finalFormateado = _a.finalFormateado, setDesactivarContador = _a.setDesactivarContador, contextoVisual = _a.contextoVisual;
    var globalConfig = useAppSelector(function (state) { return state.empresa && state.empresa.globalConfig; });
    var currentOffsetDate = new Date().getTimezoneOffset();
    var countdownEndDate = new Date(finalFormateado).getTime() + currentOffsetDate * 60 * 1000;
    return (finalFormateado && (React.createElement(StyledContador, { contextoVisual: contextoVisual },
        React.createElement("div", null,
            contextoVisual !== "hotSale" && (React.createElement(React.Fragment, null,
                React.createElement(FontAwesomeIcon, { icon: globalConfig.hotSale.iconoHotSale, size: "sm" }),
                " ")),
            contextoVisual === "hotSale"
                ? globalConfig.hotSale.termina
                : globalConfig.hotSale.textoHotSale,
            ":"),
        React.createElement(Countdown, { daysInHours: true, date: countdownEndDate, onComplete: function () {
                setTimeout(function () { return setDesactivarContador(false); }, 3000);
            } }))));
};
export default ContadorHotSale;
